import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import AppShell from "@/components/layout/AppShell";
import AuthGuard from "@/components/auth/AuthGuard";
import AuthPage from "@/pages/auth/page";
import RootRedirect from "@/components/auth/RootRedirect";
import IngresoPage from "@/pages/ingreso/page";
import AdminDashboard from "@/pages/admin/dashboard/page";
import AdminCatalog from "@/pages/admin/catalogo/page";
import AdminInventory from "@/pages/admin/inventario/page";
import AdminSales from "@/pages/admin/ventas/page";
import AdminConsignaciones from "@/pages/admin/consignaciones/page";
import AdminEncargos from "@/pages/admin/encargos/page";
import AdminClients from "@/pages/admin/clientes/page";
import AdminAdvisors from "@/pages/admin/asesores/page";
import AdminTeam from "@/pages/admin/equipo/page";
import AdminPromotions from "@/pages/admin/promociones/page";
import AdminKit from "@/pages/admin/kit/page";
import AdminCartera from "@/pages/admin/cartera/page";
import AdminContabilidad from "@/pages/admin/contabilidad/page";
import AdminBackup from "@/pages/admin/respaldo/page";
import AsesorHome from "@/pages/asesor/page";
import AsesorCatalog from "@/pages/asesor/catalogo/page";
import AsesorInventory from "@/pages/asesor/inventario/page";
import AsesorChulear from "@/pages/asesor/chulear/page";
import AsesorEncargo from "@/pages/asesor/encargo/page";
import AsesorKit from "@/pages/asesor/kit/page";
import AsesorCuenta from "@/pages/asesor/cuenta/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootRedirect />,
  },
  {
    path: "/ingreso",
    element: <IngresoPage />,
  },
  {
    path: "/acceso",
    element: <AuthPage />,
  },
  {
    element: (
      <AuthGuard>
        <AppShell />
      </AuthGuard>
    ),
    children: [
      {
        path: "/admin",
        element: <AdminDashboard />,
      },
      {
        path: "/admin/catalogo",
        element: <AdminCatalog />,
      },
      {
        path: "/admin/inventario",
        element: <AdminInventory />,
      },
      {
        path: "/admin/ventas",
        element: <AdminSales />,
      },
      {
        path: "/admin/consignaciones",
        element: <AdminConsignaciones />,
      },
      {
        path: "/admin/encargos",
        element: <AdminEncargos />,
      },
      {
        path: "/admin/clientes",
        element: <AdminClients />,
      },
      {
        path: "/admin/asesores",
        element: <AdminAdvisors />,
      },
      {
        path: "/admin/equipo",
        element: <AdminTeam />,
      },
      {
        path: "/admin/cartera",
        element: <AdminCartera />,
      },
      {
        path: "/admin/promociones",
        element: <AdminPromotions />,
      },
      {
        path: "/admin/kit",
        element: <AdminKit />,
      },
      {
        path: "/admin/contabilidad",
        element: <AdminContabilidad />,
      },
      {
        path: "/admin/respaldo",
        element: <AdminBackup />,
      },
      {
        path: "/asesor",
        element: <AsesorHome />,
      },
      {
        path: "/asesor/catalogo",
        element: <AsesorCatalog />,
      },
      {
        path: "/asesor/inventario",
        element: <AsesorInventory />,
      },
      {
        path: "/asesor/chulear",
        element: <AsesorChulear />,
      },
      {
        path: "/asesor/encargo",
        element: <AsesorEncargo />,
      },
      {
        path: "/asesor/kit",
        element: <AsesorKit />,
      },
      {
        path: "/asesor/cuenta",
        element: <AsesorCuenta />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;